import BlockComponentText from '../../../models/BlockComponentValues/BlockComponentText';
import BlockComponentImage from '../../../models/BlockComponentValues/BlockComponentImage';

class BlockTitleData {
  title: BlockComponentText;
  url?: BlockComponentImage;
}

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace BlockTitleData {
  export function make(title: string, url?: string): BlockTitleData {
    return {
      title: BlockComponentText.make(title),
      url: BlockComponentImage.make(url),
    };
  }

  export function getDefault(title = 'タイトル'): BlockTitleData {
    return make(`<p><strong style="font-size: 36px;">${title}</strong></p>`);
  }
}

export default BlockTitleData;
